const MIME_TYPES = {
    XLSX: "application/vnd.ms-excel",
    PDF: "application/pdf",
};

export const getHeaders = (noCache = false, filename = undefined) => {
    const headers = {
        "Content-Type": "application/json",
        "T3-SITEID": "admin",
    };

    const token = localStorage.getItem("AUTH-TOKEN");
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    if (noCache) {
        headers["Cache-Control"] = "no-cache";
        headers.Pragma = "no-cache";
    }

    if (filename) {
        const ext = filename.split(".").pop().toUpperCase();
        if (MIME_TYPES[ext]) {
            headers.Accept = MIME_TYPES[ext];
        }
    }

    return headers;
};
